export * from "./bullet-pagination.component";
